import React from "react";

const AccessibilityTh = ({ children, ...params }) => {
    return (
        <th scope='col' {...params}>
            {children}
        </th>
    );
};
export default AccessibilityTh;
